export default __webpack_public_path__ + "img/cPqMeSye.62dd9fe5.svg";